import { put, call, delay, select } from "redux-saga/effects";
import EmpowerActions from 'stores/leadbest-official-website/empower/actions';
import errorHandlerSaga from '../errorHandlerSaga';
import {
    getEmpower, getEmpowerDetails,
} from 'services/leadbest-official-website/empowerApi';

export function* getEmpowerSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(getEmpower, payload);
        yield put(EmpowerActions.getEmpowerSuccess(res));
    } catch (error) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(EmpowerActions.getEmpowerError(errorHandler));
    }
}

export function* getEmpowerDetailsSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(getEmpowerDetails, payload);
        yield put(EmpowerActions.getEmpowerdetailsSuccess(res));
    } catch (error) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(EmpowerActions.getEmpowerdetailssError(errorHandler));
    }
}